__turbopack_context__.v({
  "root": "theme-switcher-module__IeWOuW__root",
  "switch": "theme-switcher-module__IeWOuW__switch",
});
